import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import AgencyAcquisitions from "@/pages/AgencyAcquisitions";
import PropertyPortfolios from "@/pages/PropertyPortfolios";
import OurBrands from "@/pages/OurBrands";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/agency-acquisitions" element={<AgencyAcquisitions />} />
          <Route path="/property-portfolios" element={<PropertyPortfolios />} />
          <Route path="/our-brands" element={<OurBrands />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
